import { Box, Grid, FormControl,FormLabel } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../common/FormikControl";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { updateFeasibility } from "../../../slices/feasibility";
import { SUPPORTED_FORMATS } from "../../../../pages/appointment-details/common-pre-screen/common";
import DownloadImageApi from "../../../../services/downloadImageService"
import  FileUploadComponent from '../../../pages/FeasibilityAssessment/BMRSlots/FileUploadComponent'

const ClinicalFeasibiltyForm = ({ id, handleCloseModal, onMarkAsFisable, feasibilityInfo }) => {
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState({
    feasibility: "",
    comment: "",
    media_id:[]
  });
  useEffect(() => {
    if (feasibilityInfo) {
      setInitialValues({
        feasibility: feasibilityInfo.clinical_status?.toString() || "",
        comment: feasibilityInfo.clinical_feasibility_comment || "",
        media_id: feasibilityInfo.media_id || []
      });
    }
  }, [feasibilityInfo]);

  const feasibilityOptions = [
    { value: "1", label: "Yes" },
    { value: "3", label: "No" },
    { value: "2", label: "Feasible with Conditions" },
  ]

  const validationSchema = Yup.object().shape({
    feasibility: Yup.string().trim().required("Feasibility is required"),
    comment: Yup.string().required("Comment is required"),
  })

  const handleSubmit = async (values) => {
    const payload = { ...values, feasibility_type: "CLINICAL", id: id}
    await dispatch(updateFeasibility(payload))
    onMarkAsFisable();
    handleCloseModal();
  }

      const handleDownload = async (id) => {
          try {
            const imgRes = await DownloadImageApi.getDownloadedImageul(id);
            const response = await fetch(imgRes?.data || "");
      
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response?.url;
          } catch (error) {
            // console.error("Download failed:", error);
           console.log("Download failed. Please try again later.");
          }
        };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: handleSubmit
  })

  const formOptions = [
    {
      label: 'Feasibility',
      type: 'select',
      name: 'feasibility',
      required: true,
      placeholder: 'Select one',
      options: feasibilityOptions
    },
    {
      label: "Select Attachment",
      type: "file",
      name: "media_id",
      multiple: true,
      removeButton: false,
      acceptFormat: SUPPORTED_FORMATS,
      downloadFile: handleDownload,
      placeholder: "Select a File",
      required: false,
      col: 1,
    },
    {
      label: 'Comment',
      type: 'textarea',
      name: 'comment',
      required: true,
      placeholder: 'Enter Comment here'
    }
  ]
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              {props?.type === 'file' ? (
                <FormControl variant="standard" fullWidth>
                    <FormLabel shrink required={props.required} className="text-black">
                      {props.label}
                    </FormLabel>
                     <FileUploadComponent 
                    field={props}
                    value={formik?.values[props.name]}
                     formData={{ media_id: formik.values[props.name] }}   // MUST be an object
                    setFormData={(cb) => {
                        const newState = cb({ media_id: formik.values[props.name] });
                        formik.setFieldValue(props.name, newState.media_id);
                    }}
                    error={formik?.errors[props.name]}
                    touched={formik?.touched[props.name]}
                  />
                </FormControl>):
              <FormikControl formik={formik} {...props} />}
            </Grid>
          ))}
        </Grid>
        
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton fullWidth type="submit" variant="contained">Submit</LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

export default ClinicalFeasibiltyForm;